import React from "react";
import {Container} from "react-bootstrap";

import {BasePage} from "pages/base-page";
import {MainTitle} from "components/styles";
import {FadeIn} from "components/fade-in";
import {useDelayedFadeIn} from "utils/animation-delay";

export const FAQs = () => {
    const {nextDelay} = useDelayedFadeIn({});
    return <BasePage>
        <Container>
            <MainTitle className="mb-4">
                <FadeIn nextDelay={nextDelay}>
                    Frequently Asked Questions
                </FadeIn>
            </MainTitle>
           
        </Container>
    </BasePage>;
}
